import { getStoredUser, hasRole, isAdminUser } from "../../../../utils/authRoleHelpers";
import { normalizeUserKindForForm, USER_KIND } from "../../../../../infrastructure/utils/userKindUtils";

/**
 * Maps stored user → dashboard access role (mirrors backend ManagementDashboardAccessService).
 */
export const resolveManagementDashboardAccessRole = (user = getStoredUser()) => {
  if (!user) return null;
  if (isAdminUser() || Number(user.roleId ?? user.RoleId) === 1) return "CeoAdmin";

  const kind = normalizeUserKindForForm(user.userKind ?? user.UserKind);
  if (kind === USER_KIND.Management) return "CeoAdmin";
  if (kind === USER_KIND.SolarentOperator || kind === USER_KIND.Supervisor) {
    return "OperationalManager";
  }
  if (kind === USER_KIND.Investor || hasRole("Partner")) return "Finance";
  if (kind === USER_KIND.Contractor) return "Contractor";
  return null;
};

export const buildClientDashboardAccess = (serverAccess) => {
  if (serverAccess) {
    return {
      canViewDashboard: !!(serverAccess.canViewDashboard ?? serverAccess.CanViewDashboard),
      canAssignActions: !!(serverAccess.canAssignActions ?? serverAccess.CanAssignActions),
      canCompleteActions: !!(serverAccess.canCompleteActions ?? serverAccess.CanCompleteActions),
      canSyncActions: !!(serverAccess.canSyncActions ?? serverAccess.CanSyncActions),
      canExportReports: !!(serverAccess.canExportReports ?? serverAccess.CanExportReports),
      assignedActionsOnly: !!(serverAccess.assignedActionsOnly ?? serverAccess.AssignedActionsOnly),
      lendingActionsOnly: !!(serverAccess.lendingActionsOnly ?? serverAccess.LendingActionsOnly),
      accessRole: serverAccess.accessRole ?? serverAccess.AccessRole,
      userId: serverAccess.userId ?? serverAccess.UserId,
      userFullName: serverAccess.userFullName ?? serverAccess.UserFullName,
    };
  }

  const role = resolveManagementDashboardAccessRole();
  if (!role) {
    return {
      canViewDashboard: false,
      canAssignActions: false,
      canCompleteActions: false,
      canSyncActions: false,
      canExportReports: false,
      assignedActionsOnly: false,
      lendingActionsOnly: false,
      accessRole: null,
    };
  }

  if (role === "Contractor") {
    return {
      canViewDashboard: true,
      canAssignActions: false,
      canCompleteActions: true,
      canSyncActions: false,
      canExportReports: false,
      assignedActionsOnly: true,
      lendingActionsOnly: false,
      accessRole: role,
    };
  }

  if (role === "Finance") {
    return {
      canViewDashboard: true,
      canAssignActions: true,
      canCompleteActions: true,
      canSyncActions: false,
      canExportReports: true,
      assignedActionsOnly: false,
      lendingActionsOnly: true,
      accessRole: role,
    };
  }

  return {
    canViewDashboard: true,
    canAssignActions: true,
    canCompleteActions: true,
    canSyncActions: true,
    canExportReports: true,
    assignedActionsOnly: false,
    lendingActionsOnly: false,
    accessRole: role,
  };
};
